export default "__VITE_ASSET__Bzi7WtBY__"